import {Component, computed, input, OnInit, output, signal} from '@angular/core';
import {TranslocoDirective, TranslocoService} from '@jsverse/transloco';
import {
  Campaign,
  CampaignType,
  CampaignUserStatus,
  getCampaignLocationDisplayString,
  Size,
  TimeConditionsType,
} from '../../services/model';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {CampaignCardPromoDetailsComponent} from './campaign-card-promo-details/campaign-card-promo-details.component';
import {MatButtonModule} from '@angular/material/button';
import {CampaignCardSponsorHeaderComponent} from './action-card-sponsor-header/campaign-card-sponsor-header.component';
import {
  CampaignCardSentenceMerchantComponent
} from './campaign-card-sentence-merchant/campaign-card-sentence-merchant.component';
import {
  CampaignCardSentenceSponsorComponent
} from './campaign-card-sentence-sponsor/campaign-card-sentence-sponsor.component';
import {MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion';
import {LoyaltyCurrencyPipe} from '../pipes/loyalty-currency.pipe';
import {MatIcon} from '@angular/material/icon';
import {UserActionLogService} from '../../services/user-action-log.service';


@Component({
  selector: 'app-action-card-preview',
  templateUrl: './action-card-preview.component.html',
  styleUrl: './action-card-preview.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoDirective,
    CampaignCardPromoDetailsComponent,
    MatButtonModule,
    CampaignCardSponsorHeaderComponent,
    CampaignCardSentenceSponsorComponent,
    CampaignCardSentenceMerchantComponent,
    NgOptimizedImage,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    LoyaltyCurrencyPipe,
    NgOptimizedImage,
    MatIcon,
  ],
})
export class ActionCardPreviewComponent implements OnInit {

  campaignDetails = input.required<Campaign>();
  campaignUserStatus = input<CampaignUserStatus>(CampaignUserStatus.ACTIVE);
  isStatic = input<boolean>(false);
  isDemoMode = input<boolean>(false);

  expanded = signal<boolean>(false);

  background = computed(() => {
    const campaign = this.campaignDetails();
    let coverUrl = campaign.coverUrlMobileOptimized;

    if (!coverUrl) {
      coverUrl = campaign.coverUrl ?? campaign.organization?.coverUrl;
    }

    return coverUrl ?? null;
  });

  backgroundIsBlob = computed(() => {
    const background = this.background();
    if (background) {
      return background.startsWith('blob:');
    }
    return false;
  })


  daysOfWeek = computed<string | undefined>((): string | undefined => {
    if (!this.campaignDetails().timeConditions?.daysOfWeek || this.campaignDetails().timeConditions?.daysOfWeek!.length == 0) {
      return undefined;
    }

    const weekDays = this.campaignDetails().timeConditions?.daysOfWeek!;
    if (this.campaignDetails().timeConditions?.daysOfWeek!.length == 1) {
      return this.transloco.translate(`weekDays.${weekDays[0]}`);
    } else {
      return weekDays
        .map((weekDay: any) =>
          this.transloco.translate(`weekDays.${weekDay}_short`)
        )
        .join(',');
    }
  });

  location = computed<string | undefined>(() => {
    return getCampaignLocationDisplayString(this.campaignDetails());
  });

  viewLocationsOpened = output<void>();
  howToRedeemOpened = output<void>();
  valueRatingOpened = output<void>();
  loyaltyInfoOpened = output<void>();
  cardExpanded = output<void>();

  protected readonly TimeConditionsType = TimeConditionsType;
  protected readonly CampaignUserStatus = CampaignUserStatus;
  protected readonly CampaignType = CampaignType;
  protected readonly Size = Size;

  constructor(private transloco: TranslocoService, private userActionLogService: UserActionLogService) {
  }

  ngOnInit(): void {
    this.expanded.set(this.isDemoMode() || this.isStatic());
  }

  onPanelOpen(): void {
    this.withStaticCheck(() => {
      this.expanded.set(true);
      this.cardExpanded.emit();
    })

    if(!this.isDemoMode()) {
      this.userActionLogService.trackCampaignView(this.campaignDetails().id).subscribe()
    }
  }

  onPanelClose(): void {
    this.withStaticCheck(() => {
      this.expanded.set(false);
    });
  }

  withStaticCheck(callback: any): void {
    if (this.isStatic()) {
      return;
    }

    callback();
  }

  openLocationsSlideIn(): void {
    if (this.isStatic()) {
      return;
    }

    this.viewLocationsOpened.emit();
  }

  openHowToRedeemSlideIn(): void {
    if (this.isStatic()) {
      return;
    }

    this.howToRedeemOpened.emit();
  }
}
